define("settings/routes/groups/index", ["exports", "@ember/routing/route", "@ember/service", "@ember/template", "@glimmer/tracking"], function (_exports, _route, _service, _template, _tracking) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;

  var _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7;

  function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }

  function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

  function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }

  function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'proposal-class-properties is enabled and runs after the decorators transform.'); }

  let IndexRoute = (_class = class IndexRoute extends _route.default {
    constructor() {
      super(...arguments);

      _initializerDefineProperty(this, "alerts", _descriptor, this);

      _initializerDefineProperty(this, "auth", _descriptor2, this);

      _initializerDefineProperty(this, "intl", _descriptor3, this);

      _initializerDefineProperty(this, "settings", _descriptor4, this);

      _initializerDefineProperty(this, "store", _descriptor5, this);

      _initializerDefineProperty(this, "subscriptions", _descriptor6, this);

      _defineProperty(this, "groupSorting", ['name']);

      _initializerDefineProperty(this, "groups", _descriptor7, this);
    }

    get currentAccount() {
      return this.auth.currentAccount;
    }

    get isGracePeriod() {
      return this.subscriptions.subscription.isGracePeriod;
    }

    get numUsedSocialSets() {
      return this.auth.socialSets.filter(socialSet => socialSet.get('socialProfiles').length > 0).length;
    }

    get socialSetsRemaining() {
      const remaining = (this.totalSocialSets || 1) - this.numUsedSocialSets;
      return Math.max(remaining, 0);
    }

    get totalSocialSets() {
      return this.currentAccount.totalSocialSets || 1;
    }

    model() {
      return this.settings.isAccountOwner ? this.store.query('group', {
        filter: {
          account_id: this.currentAccount.id
        },
        reload: true
      }) : [];
    }

    afterModel(groups) {
      this.groups = groups;

      this._checkOverages();
    }

    setupController(controller) {
      for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        args[_key - 1] = arguments[_key];
      }

      super.setupController(...args);
      controller.setProperties({
        groups: this.groups,
        currentAccount: this.currentAccount,
        canCreateNewGroup: this.settings.canCreateNewGroup,
        socialSetsRemaining: this.socialSetsRemaining,
        totalSocialSets: this.totalSocialSets
      });
    }

    _checkOverages() {
      const account = this.currentAccount;

      if (account !== null && account !== void 0 && account.shouldWarnOfPlanOverages && !this.isGracePeriod) {
        if (account.hasGroupsOverage) {
          this.alerts.warning(this.intl.t('alerts.account.groups.overages', {
            count: account.groupsOverage
          }), {
            title: this.intl.t('alerts.account.overage')
          });
        }

        if (account.hasSocialProfileOverage) {
          const profileOverages = [account.hasInstagramOverage ? {
            type: 'Instagram',
            count: account.instagramOverage
          } : null, account.hasFacebookOverage ? {
            type: 'Facebook',
            count: account.facebookOverage
          } : null, account.hasPinterestOverage ? {
            type: 'Pinterest',
            count: account.pinterestOverage
          } : null, account.hasTwitterOverage ? {
            type: 'Twitter',
            count: account.twitterOverage
          } : null].filter(item => item).map(profile => "<li>".concat(this.intl.t('alerts.account.groups.group.social_profiles.overages.profiles', profile), "</li>"));
          const overageList = "<ul>".concat(profileOverages, "</ul>");
          this.alerts.warning(this.intl.t('alerts.account.groups.group.social_profiles.overages.title', {
            count: account.groupsOverage,
            list: (0, _template.htmlSafe)(overageList)
          }), {
            title: this.intl.t('alerts.account.overage')
          });
        }
      }
    }

  }, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "alerts", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "auth", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "intl", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "settings", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "store", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "subscriptions", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, "groups", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function () {
      return [];
    }
  })), _class);
  _exports.default = IndexRoute;
});